export default function collectionFilters() {
    let allFilterHeadings = document.querySelectorAll('.filters__title')
    let filterForm = document.querySelector('form.filters')

    if (!allFilterHeadings.length || !filterForm) {
        return
    }

    allFilterHeadings.forEach((el, index) => {
        el.addEventListener('click', function () {
            el.parentNode.classList.toggle('open')
        })
    })

    let allFilterOptions = document.querySelectorAll('.filters input')

    allFilterOptions.forEach(function (el, index) {
        el.addEventListener('change', function () {
            filterForm.submit()
        })
    })
}
